import { render, staticRenderFns } from "./ContactEmailEditModal.vue?vue&type=template&id=379e067c&scoped=true&"
import script from "./ContactEmailEditModal.vue?vue&type=script&lang=js&"
export * from "./ContactEmailEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379e067c",
  null
  
)

export default component.exports